"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// FILTER FIND HELPERS. These functions need to be called to return a function to be used
exports.findById = function (id) {
  return function (filter) {
    return filter.getIdentifier() === id;
  };
};
exports.findLeafByOn = function (on) {
  return function (filter) {
    try {
      return filter.getOn() === on;
    } catch (e) {
      return false;
    }
  };
};
// FILTER COMPARE HELPERS. These functions can be used "as is"
exports.compareById = function (filter1, filter2) {
  return filter1.getIdentifier() === filter2.getIdentifier();
};
exports.compareLeafByOn = function (filter1, filter2) {
  try {
    return filter1.getOn() === filter2.getOn();
  } catch (e) {
    return false;
  }
};